import { useLazyQuery } from '@apollo/client';
import { AccountBalanceSummaryQuery } from 'apollo/user/user.gql';
import { AccountBalanceSummaryResponse } from 'apollo/user/user.type';
import { AccountStatusEnum } from 'types/generated/graphql';
import { log } from 'utils/log';
import { usePoorStandingContext } from 'contexts/PoorStandingContext/PoorStandingContext';
import { PurchaseActionTypes } from '../Purchase.types';
import { EventIds } from '../../../../constants';
import { PurchaseAction } from './purchaseReducer';

export type HandleUserAccountStatus = () => void;

export const useHandleUserAccountStatus = ({
    dispatch,
}: {
    dispatch: React.Dispatch<PurchaseAction>;
}): HandleUserAccountStatus => {
    const { showPoorStanding } = usePoorStandingContext();

    const handleOnCompleted = (data: AccountBalanceSummaryResponse) => {
        const isPoorStanding =
            data?.accountBalanceSummary?.accountingStatus ===
            AccountStatusEnum.PoorStanding;

        showPoorStanding(isPoorStanding);

        dispatch({
            type: PurchaseActionTypes.GetCostPreview,
            isPoorStanding: isPoorStanding,
        });
    };

    const [getAccountBalanceSummary] = useLazyQuery(
        AccountBalanceSummaryQuery,
        {
            fetchPolicy: 'network-only',
            onCompleted: handleOnCompleted,
            onError: (error) => {
                log.error(
                    'Failed to get user current plan',
                    EventIds.FailedGetUserCurrentPlan,
                    error,
                );
            },
        },
    );

    return getAccountBalanceSummary;
};
